{
  "fr": {
    "notification": {
      "actions": {
        "delete": "Supprimé notification",
        "deleteAll": "Supprimer tout",
        "markAllAsRead": "Tout marquer comme lu",
        "mark_as_read": "Marquer comme lu",
        "mark_as_unread": "Marquer comme non lu"
      },
      "customers": {
        "announcement": {
          "create": "a créé une actualité. | a créé {group_notification_count} nouvelles. |_| ont créé {group_notification_count} nouvelles."
        },
        "decision": {
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "a ajouté la décision <i>'{notifiable_name}'</i>."
          },
          "relaunched": "rendu la décision <i>'{notifiable_name}'</i> à nouveau disponible."
        },
        "decision_document": {
          "create": "a téléchargé le document <i>'{notifiable_name}'</i> dans décision <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans décision <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans décision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "a approuvée proposition <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>. | a approuvée {group_notification_count} propositions dans la décision <i>'{group_name}' </i>. | a approuvé {group_notification_count} propositions dans la décision <i>'{group_name}'</i>.",
          "create": "a créé la proposition <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>. | a créé {group_notification_count} propositions dans la décision <i>'{group_name}' </i>. | a créé {group_notification_count} propositions dans la décision <i>'{group_name}'</i>.",
          "edit_approved": "a modifié la proposition approuvée <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>. | a modifié {group_notification_count} propositions approuvées dans la décision <i>'{ group_name}'</i>. | a édité {group_notification_count} propositions approuvées dans la décision <i>'{group_name}'</i>.",
          "relaunched": "a rendu la proposition rejetée <i> '{notifiable_name}' </i> à nouveau disponible | a rendu {group_notification_count} propositions rejetées dans la décision <i> '{group_name}' </i> à nouveau disponibles | a rendu {group_notification_count} propositions rejetées dans la décision <i> '{group_name}' </i> à nouveau disponibles"
        },
        "document": {
          "create": "a téléchargé le document <i>'{notifiable_name}'</i>. | a téléchargé {group_notification_count} documents. |_| ont téléchargé {group_notification_count} documents.",
          "installment": {
            "create": "a téléchargé la facture  <i>'{notifiable_name}'</i> dans une tranche de paiement. | a téléchargé {group_notification_count} factures dans une tranche de paiement. |_| ont téléchargé {group_notification_count} factures dans une tranche de paiement."
          },
          "invoice": {
            "create": "a téléchargé la facture <i>'{notifiable_name}'</i>. | a téléchargé {group_notification_count} factures. |_| ont téléchargé {group_notification_count} factures."
          },
          "proposal": {
            "create": "a téléchargé le document <i>'{notifiable_name}'</i> dans proposition <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans proposition <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans proposition <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Vos données d'exportation sont prêtes à être téléchargées."
        },
        "installment": {
          "published": "a rendu la tranche de paiement <i>'{notifiable_name}'</i> disponible. | a rendu {group_notification_count} tranches de paiement disponibles. | a rendu {group_notification_count} tranches de paiement disponibles.",
          "status": {
            "changed": "a modifié le statut de la tranche de paiement <i>'{notifiable_name}'</i> en <i>'{status}'</i>. | a modifié le statut de {group_notification_count} tranches de paiement. | a modifié le statut de {group_notification_count} tranches de paiement."
          }
        },
        "issue": {
          "approval": {
            "create": "demande d'approbation pour le point <i>'{notifiable_name}'</i> | demande d'approbation pour {group_notification_count} points. | demande d'approbation pour {group_notification_count} points."
          },
          "create": "a créé le point <i>'{notifiable_name}'</i> | a créé {group_notification_count} points pour <i>'{group_name}'</i> |_| a créé {group_notification_count} points pour <i>'{group_name}'</i>",
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>."
          },
          "status": {
            "update": "mis à jour le statut de <i>'{notifiable_name}'</i> en <i>'{status}'</i>. | mis à jour le statut de {group_notification_count} points. |_| mis à jour le statut de {group_notification_count} points."
          }
        },
        "question": {
          "create": "a créé la question <i>'{notifiable_name}'</i> dans FAQ <i>'{group_name}'</i>. | a créé {group_notification_count} questions dans <i>'{group_name}'</i>. |_| ont créé {group_notification_count} questions dans <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "N'oubliez pas de prendre une décision pour <i>'{notifiable_name}'</i>."
          },
          "installment": {
            "due": "N'oubliez pas d'effectuer un paiement pour <i>'{notifiable_name}'</i>."
          }
        },
        "survey": {
          "published": "aimerait vos commentaires concernant <i>'{group_name}'</i>."
        },
        "ticket": {
          "create": "a commencé la conversation <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>.",
            "move": "a déplacé votre message dans la conversation <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "a téléchargé un document <i>'{notifiable_name}'</i> dans la conversation <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans la conversation <i>'{group_name}'</i>. |_| a téléchargé {group_notification_count} documents dans la conversation <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "a créé une nouvelle actualité. | a créé {group_notification_count} nouvelles dans <i>'{group_name}'</i>. |_| ont créé {group_notification_count} nouvelles dans <i>'{group_name}'</i>."
        },
        "decision": {
          "mention": {
            "create": "vous a mentionné dans la conversation <i>'{group_name}'</i>. | vous a mentionné dans {group_notification_count} messages dans la conversation <i>'{group_name}'</i>. | vous a mentionné dans {group_notification_count} messages dans la conversation <i>'{group_name}'</i>."
          },
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>."
          },
          "not_interested": "n'est pas intéressé par la décision <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "vous a assigné comme responsable de la décision <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "a téléchargé <i>'{notifiable_name}'</i> dans <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents. |_| ont téléchargé {group_notification_count} documents."
        },
        "decision_proposal": {
          "approved": "a approuvé <i>'{notifiable_name}'</i> dans décision <i>'{group_name}'</i>. | a approuvé {group_notification_count} propositions dans décision <i>'{group_name}'</i>. |_| ont approuvé {group_notification_count} propositions dans décision <i>'{group_name}'</i>.",
          "create": "a créé <i>'{notifiable_name}'</i> dans décision <i>'{group_name}'</i>. | a créé {group_notification_count} propositions dans décision <i>'{group_name}'</i>. |_| ont créé {group_notification_count} propositions dans décision <i>'{group_name}'</i>.",
          "requested_changes": "a rejeté la proposition <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>. | ra rejeté {group_notification_count} propositions dans la décision <i>'{group_name}'</i>. |_| a rejeté {group_notification_count} propositions dans la décision <i>'{group_name}'</i>."
        },
        "document": {
          "create": "a téléchargé le document <i>'{notifiable_name}'</i> dans dossier <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans dossier <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans dossier <i>'{group_name}'</i>.",
          "employee_create": "a téléchargé le document <i>'{notifiable_name}'</i> dans dossier <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans dossier <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans dossier <i>'{group_name}'</i>.",
          "proposal": {
            "create": "a téléchargé le document <i>'{notifiable_name}'</i> dans proposition <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans proposition <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans proposition <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "a reçu un e-mail entrant <i>'{notifiable_name}'</i>. | a reçu {group_notification_count} e-mails entrants. |_| a reçu {group_notification_count} e-mails entrants."
          },
          "project": {
            "create": "a reçu un e-mail entrant <i>'{notifiable_name}'</i>. | a reçu {group_notification_count} e-mails entrants. |_| a reçu {group_notification_count} e-mails entrants."
          }
        },
        "export": {
          "create": "Vos données d'exportation sont prêtes à être téléchargées."
        },
        "issue": {
          "approved": "a approuvé le point <i>'{notifiable_name}'</i> pour l'unité <i>'{level_name}'</i>. | approuvé {group_notification_count} snags'</i>. |_| ont approuvé {group_notification_count} snags.",
          "create": "a créé un nouveau point pour l'unité <i>{level_name}</i> | a créé {group_notification_count} nouveaux points pour <i>{level_name}</i> |_| créé {group_notification_count} nouveaux points pour <i>{level_name}</i>",
          "mention": {
            "create": "vous a mentionné dans la conversation <i>'{group_name}'</i>. | vous a mentionné dans {group_notification_count} messages dans la conversation <i>'{group_name}'</i>. | vous a mentionné dans {group_notification_count} messages dans la conversation <i>'{group_name}'</i>."
          },
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>."
          },
          "rejected": "a rejeté le point <i>'{notifiable_name}'</i> pour l'unité <i>'{level_name}'</i>. | a rejeté {group_notification_count} points. |_| ont rejeté {group_notification_count} points."
        },
        "issue_list": {
          "responsible": {
            "update": "vous a désigné comme nouveau responsable de la liste de points <i>'{notifiable_name}'</i>."
          }
        },
        "question": {
          "create": "a créé la question <i>'{notifiable_name}'</i> dans FAQ <i>'{group_name}'</i>. | a créé {group_notification_count} questions dans FAQ <i>'{group_name}'</i>. |_| ont créé {group_notification_count} questions dans FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "à répondu à la question <i>'{group_name}'</i>."
        },
        "ticket": {
          "create": "a commencé la conversation <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "vous a mentionné dans la conversation <i>'{group_name}'</i>. | vous a mentionné dans {group_notification_count} messages dans la conversation <i>'{group_name}'</i>. |_| vous a mentionné dans {group_notification_count} messages dans la conversation <i>'{group_name}'</i>."
          },
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>."
          },
          "responsible": {
            "bulk_update": "a transféré la responsabilité de plusieurs conversations dans le projet <i>'{project_name}'</i> de <i>'{responsible_old_name}'</i> à vous.",
            "update": "vous a assigné comme responsable de la conversation <i>'{notifiable_name}'</i>."
          }
        },
        "ticket_document": {
          "create": "a téléchargé un document <i>'{notifiable_name}'</i> dans la conversation <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans la conversation <i>'{group_name}'</i>. |_| a téléchargé {group_notification_count} documents dans la conversation <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "a assigné la tâche <i>'{notifiable_name}'</i> à vous dans la liste <i>'{group_name}'</i>. | a assigné {group_notification_count} tâches à vous dans la liste <i>'{group_name}'</i>. | ont assigné la tâche <i>'{notifiable_name}'</i> à vous dans la liste <i>'{group_name}'</i>. | ont assigné {group_notification_count} tâches à vous dans la liste <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "Tous les projets",
        "allDecisions": "Toutes les décisions",
        "allStatuses": "Tout",
        "compactView": "Vue compacte",
        "expandedView": "Vue étendue",
        "filter": "Filtre",
        "hideDecisionFilter": "Masquer le filtre de décision",
        "hideExtraFilters": "Cacher les filtres supplémentaires",
        "noNewNotification": "Pas de nouvelles notifications",
        "noResults": "Pas de résultat. Essayez autre chose!",
        "none": "Vous n'avez actuellement aucune notification.",
        "notification_level_name_asc": "Unité A->Z",
        "notification_level_name_desc": "Unité Z->A",
        "pinSidebar": "Épingler",
        "showDecisionFilter": "Monter le filtre de décision",
        "showExtraFilters": "Afficher les filtres supplémentaires",
        "sort": "Sorte par",
        "status": "Statut",
        "unpinSidebar": "Désépingler",
        "unreadOnly": "Non lu",
        "updated_at_asc": "Le plus ancien d'abord",
        "updated_at_desc": "Le plus récent d'abord"
      },
      "other_user": "et 1 autre",
      "other_users": "et 1 autre | et {count} autres",
      "partners": {
        "decision": {
          "message": {
            "create": "a envoyé un nouveau message dans la conversation <i>'{group_name}'</i>. | a envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>. |_| ont envoyé {group_notification_count} nouveaux messages dans la conversation <i>'{group_name}'</i>."
          },
          "not_interested": "n'est pas intéressé par la décision <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "a commencé <i>'{notifiable_name}'</i>. | a commencé {group_notification_count} <i>'{group_name}'</i> décisions. |_| ont commencé {group_notification_count} <i>'{group_name}'</i> décisions."
          }
        },
        "decision_document": {
          "create": "a téléchargé <i>'{notifiable_name}'</i> dans <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans <i>'{group_name}'</i>"
        },
        "decision_proposal": {
          "approved": "a approuvé <i>'{notifiable_name}'</i> dans décision <i>'{group_name}'</i>. | a approuvé la proposition dans décision <i>'{group_name}'</i>. | ont approuvé la propositions dans décision <i>'{group_name}'</i>. | ont approuvé des propositions dans décision <i>'{group_name}'</i>.",
          "create": "a créé <i>'{notifiable_name}'</i> dans décision <i>'{group_name}'</i>. | a créé {group_notification_count} propositions dans décision <i>'{group_name}'</i>. |_| ont créé {group_notification_count} propositions dans décision <i>'{group_name}'</i>.",
          "requested_changes": "a rejeté la proposition <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>. | ra rejeté {group_notification_count} propositions dans la décision <i>'{group_name}'</i>. |_| a rejeté {group_notification_count} propositions dans la décision <i>'{group_name}'</i>."
        },
        "document": {
          "create": "a partagé le document <i>'{notifiable_name}'</i> avec vous. | a partagé {group_notification_count} documents avec vous. |_| ont partagé {group_notification_count} documents avec vous.",
          "proposal": {
            "create": "a téléchargé le document <i>'{notifiable_name}'</i> dans proposition <i>'{group_name}'</i>. | a téléchargé {group_notification_count} documents dans proposition <i>'{group_name}'</i>. |_| ont téléchargé {group_notification_count} documents dans proposition <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Vos données d'exportation sont prêtes à être téléchargées."
        },
        "issue": {
          "status": {
            "update": "mis à jour le statut d'un point dans <i>'{group_name}'</i>. | mis à jour le statut de {group_notification_count} points dans <i>'{group_name}'</i>. |_| mis à jour le statut de {group_notification_count} points dans <i>'{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "publié une liste de points <i>'{notifiable_name}'</i> | publié la liste de points <i>'{notifiable_name}'</i> pour {group_notification_count} unités |_| publié la liste de points <i>'{notifiable_name}'</i> pour {group_notification_count} unités"
        },
        "reminder": {
          "due": "<i>'{notifiable_name}'</i>  n'a pas été décidé pour l'unité {level_name}."
        },
        "ticket_document": {
          "create": "document téléchargé <i>'{notifiable_name}'</i> dans la conversation <i>'{group_name}'</i>. | documents téléchargés {group_notification_count} dans la conversation <i>'{group_name}'</i>. | | documents téléchargés {group_notification_count} dans la conversation <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "a ajouté client <i>'{customer_group_name}'</i> a unité <i>'{notifiable_name}'</i> pour décision <i>'{group_name}'</i>."
        }
      },
      "title": "Notifications"
    }
  }
}
